import useAppStore from "@/context/store";

// 通过指定标识去匹配杂货铺配置的单页请求量
// https://grocery.huaban.com/put/25
let configCache = {};
export const getPageSize = (mark) => {
  let pageSize = 20;
  if (configCache[mark]) {
    return configCache[mark];
  }
  let customPageSize = useAppStore.getState()?.config?.customPageSize;

  for (let key in customPageSize) {
    let config = customPageSize[key].map((item) => item.trim());
    if (config.includes(mark)) {
      pageSize = Number(key);
      configCache[mark] = pageSize;
      break;
    }
  }

  return pageSize;
};
